import { SIZING_KIT_DISCOUNT } from '@/app/consts/discounts';
import type { RefreshCart_cart_refreshCart_cart } from '@/queries/types/RefreshCart';

interface PromosFromCart {
  appliedDiscountCode: string;
  promotionCodes: (string | null | undefined)[];
}

const getPromosFromCart = (
  cart: RefreshCart_cart_refreshCart_cart | null | undefined,
): PromosFromCart => {
  const cartPromos = cart?.promotions ?? [];
  const promotionCodes = cartPromos.map(
    (promotion) => promotion?.promotionCode,
  );
  const appliedDiscountCode =
    promotionCodes.find((code) => code !== SIZING_KIT_DISCOUNT) ?? '';

  return { appliedDiscountCode, promotionCodes };
};

export default getPromosFromCart;
